import { useAppStateStore } from '@/features/application'
import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
import { MachineEtat } from '@/features/domaine/machine-etats'
import { CloneDrfConfiguration, CreationDrfConfiguration } from '@/features/interface/demande/ajouter-drf/CreationDrfConfiguration.ts'
import type { CloneDrfLaunch } from '@/features/interface/demande/ajouter-drf/types.ts'
import api from '@/features/services/demande/DemandeAllService.ts'

export function useAjouterDrf() {
  const appState = useAppStateStore()
  async function showDialog() {
    if (!appState.autoriseEcriture('FPE'))
      throw "Création DRF non autorisée"

    const engine = new MachineEtat(CreationDrfConfiguration)
    const result = await engine.launch({
      titre: 'Nouvelle DRF',
      contextCourant: TypesContextesAutorisesEnum.Adherent,
      launchParams: undefined,
    })

    return await api.addDemande(result)
  }

  async function showClone(options: CloneDrfLaunch) {
    if (!appState.autoriseEcriture('FPE'))
      throw "Duplication DRF non autorisée"

    const engine = new MachineEtat(CloneDrfConfiguration)
    const result = await engine.launch({
      titre: 'Dupliquer la DRF',
      contextCourant: TypesContextesAutorisesEnum.Adherent,
      launchParams: options,
    })

    return await api.addDemande(result)
  }

  return { showDialog, showClone }
}
